// extracted by mini-css-extract-plugin
module.exports = {"meny":"core_meny__r-uvs"};